import copy from 'copy-to-clipboard'
import { ref, reactive, computed, toRaw, watch } from 'vue'
import { log, sortBy, keyBy, getCountry } from '@/utils'

export const server = 'https://quakelife.ru/diabotical/streamers'

export const oldStorage = JSON.parse(localStorage.getItem('diabotical/avatars') || '{"myAvatars": []}')
export const storage = JSON.parse(localStorage.getItem('diabotical/streamers') || '{"myAvatars": [], "favorites": []}')
export const isImportAvailable = oldStorage.myAvatars.length > storage.myAvatars.length

export function saveStorage() {
  localStorage.setItem(
    'diabotical/streamers',
    JSON.stringify({
      config: toRaw(config),
      myAvatars: myAvatars.value,
      favorites: favorites.value,
    })
  )
}

export function importAvatars() {
  const oldStorage = JSON.parse(localStorage.getItem('diabotical/avatars') || '{"myAvatars": []}')
  const oldMyAvatars = []
  const missedAvaras = []
  if (oldStorage.myAvatars.length) {
    for (const oldName of oldStorage.myAvatars) {
      const newChannel = channels.value.find(channel => channel.name.toLowerCase() === oldName.toLowerCase())
      if (newChannel) {
        oldMyAvatars.push(newChannel.id)
      } else {
        missedAvaras.push(oldName)
      }
    }
    if (window.confirm(`You can import ${oldMyAvatars.length} of ${oldStorage.myAvatars.length} your avatars. Are you sure?`)) {
      for (const avatar of oldMyAvatars) {
        addAvatar(avatar)
      }
      if (missedAvaras.length) {
        console.warn(`${missedAvaras.length} missed avatars: ${missedAvaras.join(', ')}`)
        window.alert(`${missedAvaras.length} missed avatars: ${missedAvaras.join(', ')}`)
      }
    }
  } else {
    window.alert("Can't find your avatars there")
  }
}

export function exportAvatars() {
  if (myAvatars.value) {
    const list = myAvatars.value
      .map(id => channelsById.value[id])
      .filter(channel => channel)
      .map(channel => channel.name)
    list.sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
    copy(list.join(', '))
    window.alert(`The list of your avatars in the clipboard`)
  } else {
    window.alert(`You don't have any avatars`)
  }
}

// Common

const defaultConfig = {
  debug: false,
  server: 'https://quakelife.ru/diabotical/streamers',
  settings: true,
  autoOpen: false,
  leaderboard: window.innerWidth >= 600,
  channels: true,
  liveStreams: true,
  liveUpdates: 10 * 1000,
  liveTimers: true,
  livePreviews: true,
  previewUpdates: 5 * 60 * 1000,
  // info
  icons: true,
  iconType: 'Avatar',
  iconSize: 50,
  names: true,
  followers: true,
  followersDiff: false,
  language: true,
  partners: false,
  possession: true,
  favorites: true,
  lastStream: true,
  streamsSort: 'viewers',
  streamsFilter: 'all',
  channelsSort: 'streamedAt',
  channelsFilter: 'all',
}

export const config = reactive(Object.assign(defaultConfig, storage.config || {}))

export function toggleConfigKey(key, values) {
  const index = values.indexOf(config[key])
  if (index === -1 || index === values.length - 1) {
    config[key] = values[0]
  } else {
    config[key] = values[index + 1]
  }
}

/* ################################################################################# */
/* Focus
/* ################################################################################# */

export const focus = ref(!document.hidden)

window.addEventListener('focus', () => (focus.value = true))

window.addEventListener('blur', () => (focus.value = false))

// Filter ######################################################################################

export const filter = reactive({
  name: '',
  language: null,
})

// Storage

export const favorites = ref(storage.favorites || [])

export const myAvatars = ref(storage.myAvatars || [])

export const myAvatarsBackup = ref(myAvatars.value.concat())

export const favoritesById = reactive({})

window.favoritesById = favoritesById

watch(favoritesById, () => {
  log('changed!')
})

// Channels ######################################################################################

export const channels = ref([])

export const channelsLoading = ref(false)

export const channelsById = computed(() => keyBy(channels.value))

export const filteredChannels = computed(() => {
  const searchedName = filter.name.trim().toLowerCase()
  if (!searchedName && !filter.language) {
    return channels.value
  }
  return channels.value.filter(channel => {
    const matchName = !searchedName || channel.name.toLowerCase().includes(searchedName)
    const matchLanguage = !filter.language || filter.language === channel.flag
    return matchName && matchLanguage
  })
})

export const sortedChannels = computed(() => {
  const sortDirection = config.channelsSort === 'name' ? 'asc' : 'desc'
  return sortBy(filteredChannels.value, config.channelsSort, sortDirection)
})

export const channelCountries = computed(() => {
  const countries = []
  const countryCounts = {}
  for (const channel of channels.value) {
    countryCounts[channel.flag] = (countryCounts[channel.flag] || 0) + 1
  }
  for (const country in countryCounts) {
    if (country) {
      countries.push({ name: country, count: countryCounts[country] })
    }
  }
  return sortBy(countries, 'count')
})

export async function updateChannelsAsync() {
  channelsLoading.value = true
  return fetch(`${config.server}/channels.json`)
    .then(res => res.json())
    .then(data => {
      const newFavoritesById = {}
      for (const channel of data.channels) {
        channel.id = +channel.id
        channel.flag = getCountry(channel.language)
        newFavoritesById[channel.id] = storage.myAvatars.includes(channel.id)
      }
      Object.assign(favoritesById, newFavoritesById)
      channels.value = data.channels
      return data.channels
    })
    .catch(error => {
      console.warn(`Can't load channels`, error)
    })
    .finally(() => {
      channelsLoading.value = false
    })
}

// Streams #######################################################################################

export const streams = ref([])

export const streamsLoading = ref(false)

export const streamsById = computed(() => {
  return keyBy(streams.value)
})

export const filteredStreams = computed(() => {
  const searchedName = filter.name.trim().toLowerCase()
  return streams.value.filter(stream => {
    const matchName = !searchedName || stream.channel.name.toLowerCase().includes(searchedName)
    const matchLanguage = !filter.language || filter.language === getCountry(stream.channel.language)
    const matchFavorite = (config.streamsFavorite !== 'only' && config.streamsFavorite !== 'hidden') || (config.streamsFavorite === 'only' && favorites.value.includes(stream.id)) || (config.streamsFavorite === 'hidden' && !favorites.value.includes(stream.id))
    return matchName && matchLanguage && matchFavorite
  })
})

export const sortedStreams = computed(() => {
  const sortDirection = config.streamsSort === 'channel.name' ? 'asc' : 'desc'
  return sortBy(filteredStreams.value, config.streamsSort, sortDirection)
})

export const offlineChannels = computed(() => {
  return filteredChannels.value.filter(channel => !streamsById.value['' + channel.id])
  // .slice(0, 50)
})

export async function updateStreamsAsync() {
  streamsLoading.value = true
  return fetch(`${config.server}/streams.json`)
    .then(res => res.json())
    .then(data => {
      streams.value = data.streams
      if (config.autoOpen) {
        autoOpen()
      }
      return data.streams
    })
    .catch(error => {
      console.warn(`Can't load streams`, error)
    })
    .finally(() => {
      streamsLoading.value = false
    })
}

export function autoOpen() {
  const newAvatarChannel = getNewAvatarChannel()
  if (newAvatarChannel) {
    log('autoOpen', newAvatarChannel.name)
    config.autoOpen = false
    window.open(`https://twitch.tv/${newAvatarChannel.name}`)
  }
}

/* ################################################################################# */

export function toggleAvatar(channelId) {
  if (myAvatars.value.includes(channelId)) {
    removeAvatar(channelId)
  } else {
    addAvatar(channelId)
  }
}
export function addAvatar(channelId) {
  log('addAvatar', channelId)
  const avatarsSet = new Set(myAvatars.value)
  avatarsSet.add(channelId)
  myAvatars.value = [...avatarsSet]
  saveStorage()
}
export function removeAvatar(channelId) {
  log('removeAvatar', channelId)
  const avatarsSet = new Set(myAvatars.value)
  avatarsSet.delete(channelId)
  myAvatars.value = [...avatarsSet]
  saveStorage()
}

// Favorites
export function toggleFavorite(channelId) {
  if (favorites.value.includes(channelId)) {
    removeFavorite(channelId)
  } else {
    addFavorite(channelId)
  }
}
export function addFavorite(channelId) {
  log('addFavorite', channelId)
  const favoritesSet = new Set(favorites.value)
  favoritesSet.add(channelId)
  favorites.value = [...favoritesSet]
  saveStorage()
}
export function removeFavorite(channelId) {
  log('removeFavorite', channelId)
  const favoritesSet = new Set(favorites.value)
  favoritesSet.delete(channelId)
  favorites.value = [...favoritesSet]
}

watch([config, myAvatars, favorites], () => {
  saveStorage()
})

// watch(focus, newValue => {
//   if (newValue) {
//     if (config.livePreviews && config.previewUpdates) {
//       startUpdatingPreviews()
//     }
//     if (config.liveTimers) {
//       startLiveTimers()
//     }
//   } else {
//     stopUpdatingPreviews()
//     stopLiveTimers()
//   }
// })

watch(
  () => config.channels,
  newValue => {
    if (newValue) {
      updateChannelsAsync()
    }
  }
)

watch(
  () => config.liveStreams,
  newValue => {
    if (newValue) {
      updateStreamsAsync()
      if (config.liveUpdates) {
        startUpdatingStreams()
        if (config.livePreviews && config.previewUpdates) {
          startUpdatingPreviews()
        }
        if (config.liveTimers && config.livePreviews) {
          startLiveTimers()
        }
      }
    } else {
      stopUpdatingStreams()
    }
  }
)

watch(
  () => config.liveUpdates,
  (newValue, oldValue) => {
    if (newValue) {
      stopUpdatingStreams()
      startUpdatingStreams()
      if (!oldValue && config.previewUpdates) {
        startUpdatingPreviews()
      }
    } else {
      stopUpdatingStreams()
      stopUpdatingPreviews()
    }
  }
)

watch(
  () => config.livePreviews,
  (newValue, oldValue) => {
    if (newValue && !oldValue) {
      if (config.livePreviews && config.previewUpdates) {
        startUpdatingPreviews()
      }
      if (config.livePreviews && config.liveTimers) {
        startLiveTimers()
      }
    } else if (!newValue && oldValue) {
      stopUpdatingPreviews()
      stopLiveTimers()
    }
  }
)

watch(
  () => config.previewUpdates,
  (newValue, oldValue) => {
    if (newValue && !oldValue && config.livePreviews) {
      startUpdatingPreviews()
    } else if (!newValue && oldValue) {
      stopUpdatingPreviews()
    }
  }
)

watch(
  () => config.liveTimers,
  (newValue, oldValue) => {
    log('liveTimers', { newValue, oldValue })
    if (newValue && !oldValue && config.liveStreams) {
      startLiveTimers()
    } else if (!newValue && oldValue) {
      stopLiveTimers()
    }
  }
)

/* ################################################################################# */
/* Streams updates
/* ################################################################################# */

let updatingStreamsInterval

export function startUpdatingStreams() {
  log('startUpdatingStreams')
  updatingStreamsInterval = setInterval(updateStreamsAsync, config.liveUpdates || defaultConfig.liveUpdates)
}

export function stopUpdatingStreams() {
  log('stopUpdatingStreams')
  clearInterval(updatingStreamsInterval)
}

export function getNewAvatarChannel() {
  for (const stream of streams.value) {
    const channel = channelsById.value[stream.id]
    if (channel && channel.avatar && !myAvatars.value.includes(channel.id)) {
      return channel
    }
  }
}

/* ################################################################################# */
/* Preview updates
/* ################################################################################# */

let updatingPreviewsInterval

export const previewsTimer = ref(Date.now())

export function updatePreviews() {
  log('updatePreviews')
  previewsTimer.value = Date.now()
}

export function startUpdatingPreviews() {
  log('startUpdatingPreviews')
  updatingPreviewsInterval = setInterval(updatePreviews, config.previewUpdates || defaultConfig.previewUpdates)
}

export function stopUpdatingPreviews() {
  log('stopUpdatingPreviews')
  clearInterval(updatingPreviewsInterval)
}

/* ################################################################################# */
/* Timer updates
/* ################################################################################# */

export const liveTimer = ref(Date.now())

let liveTimerInterval

function updateLiveTimer() {
  liveTimer.value = Date.now()
}

function startLiveTimers() {
  log('startLiveTimers')
  liveTimerInterval = setInterval(updateLiveTimer, 1000)
}

function stopLiveTimers() {
  log('stopLiveTimers')
  clearInterval(liveTimerInterval)
}

// #################################################################################
// Start
// #################################################################################

if (config.liveStreams) {
  updateStreamsAsync()
  if (config.liveUpdates) {
    startUpdatingStreams()
    if (config.livePreviews && config.previewUpdates) {
      startUpdatingPreviews()
    }
    if (config.livePreviews && config.liveTimers) {
      startLiveTimers()
    }
  }
}

if (config.channels) {
  updateChannelsAsync()
}
